import React, { useEffect, useState } from 'react'
import {
  MaskedProperty,
  Property,
  PropertyWithAccess,
} from '../../../types/Property/Property'
import Card from '../../Card'
import { LeafletPoint } from '../../../types/LeafletPoint'
import dynamic from 'next/dynamic'

const LeafletMap = dynamic(() => import('../../LeafletMap'), {
  ssr: false,
})

interface PropertiesMapProps {
  properties: PropertyWithAccess[]
}

export default function PropertiesMapCard({ properties }: PropertiesMapProps) {
  const [leafletPoints, setLeafletPoints] = useState<
    LeafletPoint[] | undefined
  >()

  useEffect(() => {
    const points: LeafletPoint[] = properties
      .filter((p): p is Property & { allowed: true } => 'lat' in p && p.allowed)
      .map((p) => ({
        lat: p.lat,
        lon: p.lon,
        pin: true,
      }))

    setLeafletPoints(points)
  }, [properties])

  return (
    <Card className="h-full overflow-hidden rounded-md bg-white">
      {leafletPoints && leafletPoints.length > 0 ? (
        <LeafletMap
          centerCoordinates={[leafletPoints[0].lat, leafletPoints[0].lon]}
          zoom={4}
          leafletPoints={leafletPoints}
          classname="h-full"
        />
      ) : (
        <div className="p-4 text-center text-sm text-neutralGray">
          Aucune carte disponible
        </div>
      )}
    </Card>
  )
}
